import { showDeleteInsuranceState } from '@/atoms';
import { useDeleteInsurance } from '@/services/insurances';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil-next';
import { ModalLayout } from 'moh-ui';
import { Button } from '@mantine/core';

export default function DeleteInsuranceModal() {
   const [show, setShow] = useRecoilState(showDeleteInsuranceState);
   const queryClient = useQueryClient();
   const { mutate: deleteInsurance, isLoading: deletingInsurance } = useDeleteInsurance();

   const handleSubmit = () => {
      if (!show?.insuranceId) return;
      deleteInsurance(
         {
            id: show.insuranceId,
         },
         {
            onSuccess: () => {
               notifications.show({
                  title: 'Success',
                  message: 'Insurance deleted successfully',
                  color: 'green',
               });
               queryClient.invalidateQueries('allInsurances');
               setShow(null);
            },
            onError: (error) => {
               notifications.show({
                  title: 'Error',
                  message: error?.response?.data?.message || 'Failed to delete insurance',
                  color: 'red',
               });
            },
         },
      );
   };

   return (
      <ModalLayout open={Boolean(show?.show)} onClose={() => setShow(null)}>
         <div className="sm:flex sm:items-start">
            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
               <svg
                  className="h-6 w-6 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
               >
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                  />
               </svg>
            </div>
            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
               <h3 className="text-base font-semibold leading-6 text-gray-900" id="modal-title">
                  Delete Insurance
               </h3>
               <div className="mt-2">
                  <p className="text-sm text-gray-500">
                     Are you sure you want to delete this insurance? This action cannot be undone.
                  </p>
               </div>
            </div>
         </div>
         <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-4">
            <Button onClick={handleSubmit} disabled={deletingInsurance} type="button" color="red">
               {deletingInsurance ? 'Deleting...' : 'Delete'}
            </Button>
            <Button variant="outline" disabled={deletingInsurance} onClick={() => setShow(null)} type="button">
               Cancel
            </Button>
         </div>
      </ModalLayout>
   );
}
